import classNames from 'classnames'
import {dataProps} from 'quickstart/theme'
import type {ComponentProps} from 'react'
import S from './styles.module.css'

interface TextContainerProps extends ComponentProps<'div'> {
  justify?: 'left' | 'center' | 'right'
  variant?: 'default' | 'wider' | 'strict' | 'none'
}

export const TextContainer = ({
  justify,
  variant = 'default',
  ...props
}: TextContainerProps) => (
  <div
    data-text-container
    {...dataProps({justify, variant})}
    {...props}
    className={classNames(S['text-container'], props.className)}
  />
)
